import React from 'react';

const notFound = React.createClass({
  render() {
    return (
      <div className="main">
        <h1>404 Not Found <b>:(</b></h1>
      </div>
    );
  },
});

export default notFound;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/static/not-found.jsx
 **/